import { RootState } from 'store';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { STATIONS_STATE } from '../../constants';

export const useStationsPriceReportSettingsLoadingStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReportSettings.loadingStatus
);

export const useIsStationsPriceReportSettingsLoading = () => {
  const stationsPriceReportSettingsLoadingStatus = useStationsPriceReportSettingsLoadingStatus();
  return checkIsLoading(stationsPriceReportSettingsLoadingStatus);
};

export const useIsStationsPriceReportSettingsDone = () => {
  const stationsPriceReportSettingsLoadingStatus = useStationsPriceReportSettingsLoadingStatus();
  return checkIsLoadingDone(stationsPriceReportSettingsLoadingStatus);
};

export const useStationsPriceReportSettingsUpdatingStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReportSettings.updatingStatus
);

export const useIsStationsPriceReportSettingsUpdatingLoading = () => {
  const stationsPriceReportSettingsUpdatingStatus = useStationsPriceReportSettingsUpdatingStatus();
  return checkIsLoading(stationsPriceReportSettingsUpdatingStatus);
};

export const useIsStationsPriceReportSettingsUpdatingDone = () => {
  const stationsPriceReportSettingsUpdatingStatus = useStationsPriceReportSettingsUpdatingStatus();
  return checkIsLoadingDone(stationsPriceReportSettingsUpdatingStatus);
};

export const useStationsPriceReportSettingsDeletingStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReportSettings.deletingStatus
);

export const useIsStationsPriceReportSettingsDeletingLoading = () => {
  const stationsPriceReportSettingsDeletingStatus = useStationsPriceReportSettingsDeletingStatus();
  return checkIsLoading(stationsPriceReportSettingsDeletingStatus);
};

export const useStationsPriceReportSettings = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPriceReportSettings.data
);

export const useSortedStationsPriceReportSettingsServicePoints = () => {
  const stationsPriceReportSettings = useStationsPriceReportSettings();

  return useMemo(() => {
    const { servicePoints = [] } = stationsPriceReportSettings || {};

    return [...servicePoints].sort(firstItem => firstItem.sendInEmail ? -1 : 0)
  }, [stationsPriceReportSettings]);
};

export const useHasStationsPriceReportSettings = () => useSelector(
  (state: RootState) => !!state[STATIONS_STATE].stationsPriceReportSettings.data
);